// Google Analytics 4 with ecommerce events + Consent Mode (DPDP-friendly).
// Set REACT_APP_GA_ID (G-XXXXXXX) at build time to enable; unset = no-op.
// Nothing is stored until the visitor accepts cookies (Consent Mode default denied).
const GA_ID = process.env.REACT_APP_GA_ID;
const CONSENT_KEY = "ts_cookie_consent"; // "granted" | "denied"

let started = false;

export const gaEnabled = () => !!GA_ID;

function storedConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

// Load gtag.js once, with analytics storage denied until the visitor consents.
export function initAnalytics() {
  if (started || !GA_ID) return;
  started = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("consent", "default", {
    analytics_storage: storedConsent() === "granted" ? "granted" : "denied",
  });
  window.gtag("config", GA_ID, { send_page_view: false });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function setConsent(granted) {
  try { localStorage.setItem(CONSENT_KEY, granted ? "granted" : "denied"); } catch { /* ignore */ }
  if (window.gtag) window.gtag("consent", "update", { analytics_storage: granted ? "granted" : "denied" });
}
export const hasConsentChoice = () => storedConsent() != null;

const send = (name, params) => { if (window.gtag) window.gtag("event", name, params || {}); };

export function pageview(path) {
  send("page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

// ---- ecommerce ----
const item = (p, qty = 1) => ({
  item_id: p?.id, item_name: p?.title, item_brand: p?.brand,
  item_category: p?.category_name || p?.category, price: p?.price, quantity: qty,
});

export function viewItem(p) {
  if (!p) return;
  send("view_item", { currency: "INR", value: p.price, items: [item(p, 1)] });
}
export function addToCartEvent(p, qty = 1) {
  if (!p) return;
  send("add_to_cart", { currency: "INR", value: (p.price || 0) * qty, items: [item(p, qty)] });
}
export function beginCheckout(cartItems, value) {
  send("begin_checkout", {
    currency: "INR", value,
    items: (cartItems || []).map((i) => ({
      item_id: i.product?.id || i.product_id, item_name: i.product?.title || i.title,
      price: i.product?.price || i.price, quantity: i.quantity,
    })),
  });
}
export function purchase(order) {
  if (!order) return;
  send("purchase", {
    transaction_id: order.order_no || order.id, currency: "INR",
    value: order.total, tax: order.gst, shipping: order.shipping,
    items: (order.items || []).map((i) => ({
      item_id: i.product_id, item_name: i.title, price: i.price, quantity: i.quantity,
    })),
  });
}
